"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var button_module_scss_1 = __importDefault(require("./button.module.scss"));
function Button(props) {
    var classes = props.classes, size = props.size, outline = props.outline, children = props.children, disabled = props.disabled, centered = props.centered;
    return ((0, jsx_runtime_1.jsx)("button", __assign({ style: centered && { margin: 'auto' }, className: (0, classnames_1.default)(classes, button_module_scss_1.default.button, outline ? button_module_scss_1.default.button_outline : button_module_scss_1.default.button_solid, (size === "sm" && button_module_scss_1.default.btn_sm) ||
            (size === "md" && button_module_scss_1.default.btn_md) ||
            (size === "lg" && button_module_scss_1.default.btn_lg)) }, { children: children })));
}
exports.default = Button;
